import { reducerWithInitialState } from "typescript-fsa-reducers";
import { combineReducers } from "redux";

import { EntitiesMap } from "../../entities";
import { createBookmark, deleteBookmark } from "../actions";
import { bootstrapCompanyProjects, loadCompanyProjects } from "../../companies/actions";

export interface ProjectBookmarksMainState {
  [key: string]: boolean;
}

export interface ProjectBookmarksState {
  bookmarks: ProjectBookmarksMainState;
  entities: EntitiesMap; // Not using entities yet
}

const projectBookmarksReducer = reducerWithInitialState<ProjectBookmarksMainState>({})
  .case(createBookmark.started, (state, projectId) => {
    return { ...state, [projectId]: true };
  })
  .case(createBookmark.failed, (state, action) => {
    const projectId = action.params;
    return { ...state, [projectId]: false };
  })
  .case(deleteBookmark.started, (state, projectId) => {
    return { ...state, [projectId]: false };
  })
  .case(deleteBookmark.failed, (state, action) => {
    const projectId = action.params;
    return { ...state, [projectId]: true };
  })
  .cases([bootstrapCompanyProjects], (state, action) => {
    const map: ProjectBookmarksMainState = {};
    Object.entries(action.entities.projects).forEach(([id, project]) => {
      map[id] = project!.bookmarked || false;
    });
    return { ...state, ...map };
  })
  .cases([loadCompanyProjects.done], (state, action) => {
    const map: ProjectBookmarksMainState = {};
    Object.entries(action.result.entities.projects).forEach(([id, project]) => {
      map[id] = project!.bookmarked || false;
    });
    return { ...state, ...map };
  });

const entitiesReducer = reducerWithInitialState<EntitiesMap>({});

export default combineReducers({
  bookmarks: projectBookmarksReducer,
  entities: entitiesReducer,
});



// WEBPACK FOOTER //
// ./frontend/src/project_bookmarks/reducers/index.ts